import clsx from "clsx";

import { Alert } from "../base/Alert";
import Card from "../shared/Card/Card";
import LoadingWheel from "../shared/LoadingWheel";
import useFeatures from "../../data/Feature/useFeatures";
import { errorResolver } from "../../utils/errorResolver";
import useCustomerFeatures from "../../data/CustomerFeature/useCustomerFeatures";

interface CustomerFeatureListProps {
  customerId: string;
}

export function CustomerFeatureList({ customerId }: CustomerFeatureListProps) {
  const { features } = useFeatures();
  const { customerFeatures } = useCustomerFeatures(customerId);

  return (
    <Card title="Features" bodyClassName="px-4 divide-y divide-gray-100">
      {features.isLoading || customerFeatures.isLoading ? (
        <div className="py-4">
          <LoadingWheel />
        </div>
      ) : features.isError || customerFeatures.isError ? (
        <div className="p-4">
          <Alert
            severity="error"
            title="Error getting feature list or customer features"
            message={errorResolver(features.error)}
          />
        </div>
      ) : features.data && features.data?.length > 0 ? (
        features.data?.map((feature, i) => {
          let customerHasFeature = customerFeatures.data?.find(
            (cf) => cf.featureId === feature.id
          );
          return (
            <div className="py-4 flex justify-between" key={i}>
              <span className="text-sm font-medium">{feature.name}</span>
              <p
                className={clsx(
                  customerHasFeature
                    ? "text-green-700 bg-green-50 ring-green-600/20"
                    : "text-gray-700 bg-gray-50 ring-gray-600/20",
                  "mt-0.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset"
                )}
              >
                {customerHasFeature ? "Enabled" : "Disabled"}
              </p>
            </div>
          );
        })
      ) : (
        <div className="py-10 flex justify-center">
          <span className="text-sm font-medium text-gray-400">
            No features
          </span>
        </div>
      )}
    </Card>
  );
}
